export const DashboardTestIds = {
  CHARTS: 'dashboard-Diagramme',
  REPORT: 'dashboard-Mengenaufstellungen',
} as const;
